import { render, staticRenderFns } from "./BetgameEditBetmode.vue?vue&type=template&id=3915806a&scoped=true"
import script from "./BetgameEditBetmode.vue?vue&type=script&lang=js"
export * from "./BetgameEditBetmode.vue?vue&type=script&lang=js"
import style0 from "./BetgameEditBetmode.vue?vue&type=style&index=0&id=3915806a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3915806a",
  null
  
)

export default component.exports